import { render } from "./Dessins.vue?vue&type=template&id=6ac727a3"
import script from "./Dessins.vue?vue&type=script&lang=js"
export * from "./Dessins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__